<template>
  <div class="hub-coverage" role="status">
    <p v-if="busy"><v-progress-circular indeterminate size="13" width="2" class="mr-2" />Verbundene Health-Trainings werden ergänzt …</p>
    <p v-if="error">{{ error }} Roody-Trainings und Kurse bleiben verfügbar.</p>
    <p v-if="healthCoverage && healthCoverage.message">{{ healthCoverage.message }}</p>
    <p v-if="invalidCount">{{ invalidCount }} Einträge ohne verwertbares Datum konnten nicht zugeordnet werden.</p>
    <p v-if="serverCoverage && serverCoverage.truncated">Die Roody-Daten sind nur teilweise verfügbar. Die Zahlen bilden diesen Teil ab.</p>
  </div>
</template>
<script>
export default {
  props: { serverCoverage: { type: Object, default: null }, healthCoverage: { type: Object, default: null }, busy: Boolean, error: String },
  computed: {
    invalidCount() { return Object.values(this.serverCoverage?.invalidRecords || {}).reduce((sum, value) => sum + (Number(value) || 0), 0) },
  },
}
</script>
<style scoped>
.hub-coverage p { color: #bbb; font-size: 12px; line-height: 1.6; margin: 8px 0; }
</style>
